<h3>Added by: {{ (assistance.user | resolveUser).email }}</h3>

<rsValidForm #form="rsValidForm" [rsValidOnceInteracted]="true">
  <div class="inputs">
    <div class="row">
      <div class="col-4">
        <mat-form-field appearance="fill" floatLabel="always" class="w-100">
          <mat-label>Type</mat-label>
          <mat-select [(ngModel)]="assistance.type" rsValid="required" (ngModelChange)="onAssistanceTypeChange($event)">
            <mat-option *ngFor="let type of dataService.assistanceProvidedTypes | async" [value]="type.id">{{ type.name }} - {{ (type.category | resolveCategory).name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field appearance="fill" floatLabel="always" class="w-100">
          <mat-label>Date</mat-label>
          <input matInput [ngxMatDatetimePicker]="picker" placeholder="Choose a date" [(ngModel)]="assistance.date" rsValid="required">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <ngx-mat-datetime-picker #picker [showSpinners]="true" [showSeconds]="false">
          </ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
          <mat-label>Flag for follow-up</mat-label>
          <mat-slide-toggle
            [(ngModel)]="assistance.flagged"
            style="user-select: none;"
          >
            <ng-container *ngIf="assistance.flagged">Follow-up
              <mat-icon style="vertical-align: middle;" color="primary">flag</mat-icon>
            </ng-container>
            <ng-container *ngIf="!assistance.flagged">Complete <!--<mat-icon style=veritcal-align: middle; color="accent">check</mat-icon>--></ng-container>
          </mat-slide-toggle>
          <textarea matInput hidden style="display: none !important;"></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="inputs">
    <div class="row">
      <div class="col-4">
        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
          <mat-label>Risk Addressed</mat-label>
          <mat-select [(ngModel)]="assistance.riskAddressed" rsValid="required" [placeholder]="(filteredRisks | async)?.length === 0 ? 'No risks found' : ''">
            <mat-option *ngFor="let risk of filteredRisks | async" [value]="risk.id">{{ risk.name }} - {{ (risk.category | resolveCategory).name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-4">
        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
          <mat-label>Plan Activity</mat-label>
          <mat-select [(ngModel)]="assistance.planActivity" rsValid="required">
            <mat-option *ngFor="let planActivity of (dataService.localDefinitions | async)?.actionPlans" [value]="planActivity.id">{{ planActivity.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-2">
        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
          <mat-label>Learnt New Skills</mat-label>
          <mat-slide-toggle
            [(ngModel)]="assistance.learntNewSkills"
            style="user-select: none;"
          >
            <ng-container *ngIf="assistance.learntNewSkills">Yes
              <mat-icon style="vertical-align: middle;" color="primary">check</mat-icon>
            </ng-container>
            <ng-container *ngIf="!assistance.learntNewSkills">No</ng-container>
          </mat-slide-toggle>
          <textarea matInput hidden style="display: none !important;"></textarea>
        </mat-form-field>
      </div>

      <div class="col-2">
        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
          <mat-label>Intent to Change</mat-label>
          <mat-slide-toggle
            [(ngModel)]="assistance.intentToChange"
            style="user-select: none;"
          >
            <ng-container *ngIf="assistance.intentToChange">Yes
              <mat-icon style="vertical-align: middle;" color="primary">check</mat-icon>
            </ng-container>
            <ng-container *ngIf="!assistance.intentToChange">No</ng-container>
          </mat-slide-toggle>
          <textarea matInput hidden style="display: none !important;"></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="inputs">
    <div class="row">
      <div class="col-2">
        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
          <mat-label>Practice Change</mat-label>
          <mat-slide-toggle
            [(ngModel)]="assistance.practiceChange"
            style="user-select: none;"
          >
            <ng-container *ngIf="assistance.practiceChange">Yes
              <mat-icon style="vertical-align: middle;" color="primary">check</mat-icon>
            </ng-container>
            <ng-container *ngIf="!assistance.practiceChange">No</ng-container>
          </mat-slide-toggle>
          <textarea matInput hidden style="display: none !important;"></textarea>
        </mat-form-field>
      </div>

      <div class="col-2">
        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
          <mat-label>Grant Applied For</mat-label>
          <mat-slide-toggle
            [(ngModel)]="assistance.grantAppliedFor"
            style="user-select: none;"
          >
            <ng-container *ngIf="assistance.grantAppliedFor">Yes
              <mat-icon style="vertical-align: middle;" color="primary">check</mat-icon>
            </ng-container>
            <ng-container *ngIf="!assistance.grantAppliedFor">No</ng-container>
          </mat-slide-toggle>
          <textarea matInput hidden style="display: none !important;"></textarea>
        </mat-form-field>
      </div>

      <div class="col-4">
        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
          <mat-label>Grant Name</mat-label>
          <input matInput [(ngModel)]="assistance.grantAppliedForName" placeholder="Grant Name" [disabled]="assistance.grantAppliedFor === false"  />
        </mat-form-field>
      </div>

      <div class="col-4">
        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
          <mat-label>Referral for Additional Support</mat-label>
          <mat-select [(ngModel)]="assistance.referralForAdditionalSupport" rsValid="required">
            <mat-option *ngFor="let additionalSupport of (dataService.localDefinitions | async)?.additionalSupport" [value]="additionalSupport.id">{{ additionalSupport.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>
  </div>

  <div class="inputs">
    <div class="input full">
      <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
        <mat-label>Notes</mat-label>
        <input matInput [(ngModel)]="assistance.notes" placeholder="Notes"/>
      </mat-form-field>
    </div>
  </div>
</rsValidForm>

<mat-divider></mat-divider>
<br/>
<h2>Extension Activities</h2>

<mat-list class="odd-even-list mb-2" *ngIf="activitiesByCategories().length">
  <mat-list-item *ngFor="let activity of activitiesByCategories()">
    <ng-container *ngTemplateOutlet="extensionActivity; context: activity"></ng-container>
  </mat-list-item>

  <!-- Pass in variables -->
  <ng-template #extensionActivity let-key="key" let-type="type">
    <div class="d-flex justify-content-between">
      <div class="align-content-center">
        <app-category-tag [category]="type.category"></app-category-tag>
      </div>
      <div class="align-content-center">
        {{ type?.name }}
      </div>
      <div class="align-content-center">
        <button mat-icon-button color="primary" (click)="addToActivity(key, -1)">
          <mat-icon>remove_circle</mat-icon>
        </button>
        {{ assistance.activities[key] }}
        <button mat-icon-button color="primary" (click)="addToActivity(key, 1)">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
    </div>
  </ng-template>
</mat-list>

<div>
  <mat-form-field appearance="fill" floatLabel="always" style="width: 520px; display: inline-block;">
    <mat-label>Add activity:</mat-label>

    <mat-select [(ngModel)]="selectActivity">
      <mat-select-trigger>
        <ng-container *ngIf="selectActivity">
          <mat-icon>{{ selectActivity.categoryIcon }}</mat-icon>
          {{ selectActivity.categoryName }} - {{ selectActivity.name }}
        </ng-container>
      </mat-select-trigger>
      <mat-option>
        <ngx-mat-select-search placeholderLabel="Search" noEntriesFoundLabel="Nothing found.." [ngModel]="activitySearch" (ngModelChange)="activitySearch = $event; filterActivities(assistance.type)"></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let activity of filteredActivities | async" [value]="activity">
        <mat-icon>{{ activity.categoryIcon }}</mat-icon>
        {{ activity.categoryName }} - {{ activity.name }}
      </mat-option>
    </mat-select>
    <button matSuffix mat-icon-button color="accent" (click)="$event.stopPropagation(); $event.preventDefault(); addActivity(selectActivity)">
      <mat-icon>add</mat-icon>
    </button>
  </mat-form-field>
</div>


<br/>
<ng-template #actionButtons>

  <button mat-button (click)="cancel()">
    Cancel
  </button>

  <button color="primary" mat-button (click)="saveAssistance()">
    <mat-icon>save</mat-icon>
    Save
  </button>

</ng-template>
